var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"font-size-sm-100 font-weight-boldest text-dark-75 mt-15",staticStyle:{"font-size":"150px"}},[_vm._v(" "+_vm._s(_vm.$t("title.error.notFound"))+" ")]),_c('p',{staticClass:"font-size-h3 font-weight-light"},[_vm._v(_vm._s(_vm.$t("page.notFound.description")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }